import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import { useTelegram } from './hooks/useTelegram';
import Header from './components/Header/Header';
import Form from './components/Form/Form';



function App() {
  const { tg, onToggleButton } = useTelegram();
  useEffect(() => {
    tg.ready();
  }, [])

  return (
    <div className="App">
      {/* <Header />  */}
      <Form />
     {/* <button onClick={onToggleButton}>toogle</button> */}

    </div>
  );
}

export default App;
